import { render, staticRenderFns } from "./NominaPension.vue?vue&type=template&id=e6801e7e&"
import script from "./NominaPension.vue?vue&type=script&lang=js&"
export * from "./NominaPension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports